export default __webpack_public_path__ + "static/media/about-us-icon-convenience.c652d91b.png";